import { cn } from '@commenda/utils';
import React from 'react';

const SalesTaxSectionLayout = ({
  children,
  title,
  renderHeader,
  _className = '',
}: {
  children: React.ReactNode;
  title?: string;
  renderHeader?: () => React.ReactNode;
  _className?: string;
}) => {
  if (renderHeader) {
    return (
      <div className={cn('flex flex-col gap-6', _className)}>
        {renderHeader ? renderHeader() : null}
        {children}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {title ? (
        <h1 className="txt-extra-large-bold text-text-secondary">{title}</h1>
      ) : null}
      {children}
    </div>
  );
};

export default SalesTaxSectionLayout;
